import React, { Component, useRef } from 'react';
import { useParams } from 'react-router-dom';

import styles from './AccountHome.module.scss';
import { ViewHost } from '../../components';
import Students from '../../components/students/Students';

export default function AccountHome() {
    const params = useParams();

    return (
        <ViewHost viewTitle="Account Home">
            <div className={styles.host}>
                <Students familyId={params.familyId} />
            </div>
        </ViewHost>
    );
}
